import { Text } from '@/components/atoms/Text';
import styled from '@emotion/styled';
import { Title } from '@/components/atoms/Title';

export const Container = styled.div`
    flex: 1;
    padding: ${({ theme }) => theme.savory.spacing[3]};
    background-color: ${({ theme }): string => theme.color.grey300};
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.savory.spacing[3]};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;

    ${({ theme }) => theme.breakpoints.tablet} {
        flex-direction: column;
    }
`;

export const FlexGrow = styled.div`
    flex-grow: 1;
`;

export const BillingTitle = styled(Title)`
    ${({ theme }) => theme.savory.typography.Title5};
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[3]};
    max-width: 50%;
`;

export const Subtitle = styled(Text)`
    ${({ theme }) => theme.savory.typography['Body/Regular/Text2']};
`;
